import {buildRoute} from '../../../../http';

import {
  createTag,
  getTags,
  editTag,
  deleteTag,
  endpoints,
  setTagToConversation,
  setStateToConversation,
} from '../api/conversationTag';

import type {
  ConversationTag,
  PaginationResponse,
  Conversation,
  ConversationState,
} from '../../../../entities';
import {conversationAdapter} from '../utils/conversation-adapter';

export function createConversationTagService(
  tag: string
): Promise<ConversationTag> {
  return createTag({tag}).toPromise();
}

export function getConversationTagsService(): Promise<
  PaginationResponse<ConversationTag>
> {
  return getTags().toPromise();
}

export function editConversationTagService(
  tagId: string,
  tag: string
): Promise<ConversationTag> {
  const route = buildRoute(endpoints.EDIT_TAG, [tagId]);

  return editTag({tag}, {route}).toPromise();
}

export function deleteConversationTagService(tagId: string): Promise<void> {
  const route = buildRoute(endpoints.DELETE_TAG, [tagId]);

  return deleteTag({route}).toPromise();
}

export function setTagToConversationService(
  conversationId: string,
  crmTagIds: string[]
): Promise<Conversation> {
  const route = buildRoute(endpoints.UPDATE_CONVERSATION, [conversationId]);

  return setTagToConversation({crmTagIds}, {route})
    .toPromise()
    .then(conversation => {
      return conversationAdapter(conversation);
    });
}

export function changeConversationStateService(
  conversationId: string,
  state: ConversationState
): Promise<Conversation> {
  const route = buildRoute(endpoints.UPDATE_CONVERSATION, [conversationId]);

  return setStateToConversation({state}, {route})
    .toPromise()
    .then(conversation => {
      return conversationAdapter(conversation);
    });
}
